export const DeleteSupplierXrefModal = {
  headerText: `Unlink Customer Supplier ID {{customer_supplierId}}`,
  bodyText: `Are you sure you want to unlink customer from this supplier?`,
  btnConfirm: `Unlink Customer`,
  btnCancel: 'Cancel',
  allowDelete: true
};
